import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slider", "value", "suffix", "gridPoint", "label"];
  static classes = ["gridPointActive", "gridPointInactive", "valueActive"];

  connect() {
    this.updateValue(this.sliderTarget);
  }

  sliderChanged({ target }) {
    this.updateValue(target);
  }

  updateValue({ value }) {
    this.valueTarget.innerText = value;
  }

  focus() {
    this.setSliderActive(true);
  }

  blur() {
    this.setSliderActive(false);
  }

  setSliderActive(active) {
    this.gridPointTargets.forEach((gridPoint) => {
      gridPoint.classList.toggle(this.gridPointActiveClass, active);
      gridPoint.classList.toggle(this.gridPointInactiveClass, !active);
    });

    this.labelTarget.classList.toggle(this.valueActiveClass, active);
  }
}
